import { Note, NoteStatusStates, NoteTypes } from '@lyrahealth-inc/shared-app-logic/src/models/notes/Notes'

import { ROLES, SUPERVISOR_ROLES } from '../../../common/constants/appConstants'
import { hasRole } from '../../../common/utils/utils'

/**
 * Roles allowed to delete any provider's draft Care Referral. Mirrors the backend's supervisor
 * list for note DELETE (Role.supervisor_role_names() in LyraTherapy, LCDELIVERY-7933).
 *
 * The app-wide SUPERVISOR_ROLES is missing the clinical leave evaluator supervisor. It's added
 * here only, so routing and other SUPERVISOR_ROLES consumers are unaffected.
 */
export const CARE_REFERRAL_DELETE_SUPERVISOR_ROLES: string[] = [
  ...SUPERVISOR_ROLES,
  ROLES.LT_CLINICAL_LEAVE_EVALUATOR_SUPERVISOR,
]

type CanDeleteCareReferralDraftArgs = {
  note: Pick<Note, 'note_type' | 'status' | 'provider_id'> | null | undefined
  /** The signed-in person: the supervisor when one is signed in, otherwise the provider. */
  signedInLyraId: string | null | undefined
  signedInRoles: string[] | null | undefined
}

/**
 * Whether to show "Delete draft" for a note. Matches the backend rule (LCDELIVERY-7933): only a
 * draft Care Referral, and only for the note's primary provider or a supervisor. Anyone else who
 * can view the note would get a 403, so they don't see the action.
 */
export const canDeleteCareReferralDraft = ({
  note,
  signedInLyraId,
  signedInRoles,
}: CanDeleteCareReferralDraftArgs): boolean => {
  if (!note || note.note_type !== NoteTypes.REFERRAL || note.status !== NoteStatusStates.DRAFT) {
    return false
  }
  if (signedInLyraId && note.provider_id === signedInLyraId) {
    return true
  }
  return hasRole(signedInRoles, CARE_REFERRAL_DELETE_SUPERVISOR_ROLES)
}
